import { CallChaining, FormFieldWidget, FormM2OSelectFieldWidget, ModelFieldType, SPI, SubmitValue, ViewType, Widget, http } from '@kunlun/dependencies';
import { CascaderProps, message } from 'ant-design-vue';
import { cloneDeep } from 'lodash-es';
import { addressFileURL } from '../../../../utils/config';
import { queryAddressDetailList } from '../../../../api';
import deliveryAddressCopy from './AddressSelect.vue';
import { TDeliveryAddressType, TDeliveryAreaType, TIssuingMethod } from '../../../../hooks';

@SPI.ClassFactory(
    FormFieldWidget.Token({
      viewType: ViewType.Form,
      ttype: ModelFieldType.ManyToOne,
      model: [
        'deli.aries.seller.SellerDistributionCreateOrderParam',
        'deli.aries.seller.SellerDistributorAuditOrderParam',
        'deli.aries.seller.DeliAriesSellerPurchasingPlan',
        'deli.aries.merchant.DeliAriesMerchantChangeDeliveryAddress',
        'deli.aries.merchant.DeliAriesBuyerPurchasingPlan',
        'deli.aries.seller.DeliAriesSellerSpecialApplyOrder'
      ],
      name: 'deliveryAddressCopy',
      multi: false
    })
)
@SPI.ClassFactory(
    FormFieldWidget.Token({
      viewType: ViewType.Form,
      ttype: ModelFieldType.ManyToOne,
      model: [
        'deli.aries.seller.DeliAriesSellerPaperOrder'
      ],
      name: 'pcBuyerAddress',
      multi: false
    })
)
export class FormAddressSelectFieldWidget extends FormM2OSelectFieldWidget {

  @Widget.Reactive()
  private addressOptions: CascaderProps['options'] = [];

  @Widget.Reactive()
  private deliveryAddressCopy: any = {}

  public initialize(props) {
    super.initialize(props);
    this.setComponent(deliveryAddressCopy);
    return this;
  }

  async updateAddressDetailList() {
    try {
      const relationId = this.model.moduleName === 'deli.aries.seller.DeliAriesSellerPaperOrder' ? (this.formData.relationApply as any).targetPartnerId :  this.formData.buyerPartnerId || this.formData.targetPartnerId
      if (!relationId ) {
        throw { message: 'relationId is required' };
      }

      const addressList = await queryAddressDetailList(this.model, relationId);
      if (!addressList.length) {
        return;
      }
      this.addressOptions = addressList;
    } catch (error: any) {
      console.error(error?.message);
    }
  }

  @Widget.Watch('formData.buyerPartnerId')
  private watchBuyerPartnerId(val: string, oldVal) {
    
    if (oldVal !== val) {
      this.updateAddressDetailList();
      this.resetValue();
    }
  }

  @Widget.Watch('formData.relationApply')
  private watchOriginPartner(val: string, oldVal) {
    
    if (oldVal !== val) {
      this.updateAddressDetailList();
      this.resetValue();
    }
  }

  @Widget.Watch('formData.applyProxy')
  private watchTargetPartnerId(val: any, oldVal) {
    
    if (!oldVal || oldVal.id !== val.id) {
      this.updateAddressDetailList();
      this.resetValue();
    }
  }
  private resetValue() {
    this.setValue(null);
    this.addressOptions = [];
  }

  async submit(submitValue: SubmitValue) {
    return super.submit(submitValue);
  }
  @Widget.Method()
  private onChange(value: any) {
    console.log('onChange', value);
    
    super.m2oChange(value);
  }
}
